import { AsciiText } from '../framework/AsciiText';
export class Philips {
    constructor(socket, log) {
        this.socket = socket;
        this.audioOutVolume = 50;
        this.firmwareVersion = Array.from(AsciiText.encode('1.31'));
        this.input = 0x0d;
        this.modelNumber = Array.from(AsciiText.encode('BDL3230QL'));
        this.platformLabel = Array.from(AsciiText.encode('Phoenix'));
        this.platformVersion = Array.from(AsciiText.encode('2.0'));
        this.power = false;
        this.serialNumber = '0123456789ABCD';
        this.sicpVersion = Array.from(AsciiText.encode('1.88'));
        this.speakerVolume = 50;
        this.asyncHandlers = [
            {
                name: 'firmwareVersionGet',
                regExp: this.makeRegExp([0xa1, 0x01]),
                callback: (match) => {
                    this.socket.send(this.makeCommand([0xa1].concat(this.firmwareVersion)));
                },
            },
            {
                name: 'inputGet',
                regExp: this.makeRegExp(0xad),
                callback: (match) => {
                    this.socket.send(this.makeCommand([0xad, this.input, 0, 1, 0]));
                },
            },
            {
                name: 'inputSet',
                regExp: this.makeRegExp(0xac, 4),
                callback: (match) => {
                    const code = match[1].charCodeAt(0);
                    if (code >= 0x01 && code <= 0x18) {
                        this.input = match[1].charCodeAt(0);
                        this.socket.send(this.makeCommand([0x00, 0x06]));
                    }
                    else {
                        this.socket.send(this.makeCommand([0x00, 0x15]));
                    }
                },
            },
            {
                name: 'modelNumberGet',
                regExp: this.makeRegExp([0xa1, 0x00]),
                callback: (match) => {
                    this.socket.send(this.makeCommand([0xa1].concat(this.modelNumber)));
                },
            },
            {
                name: 'platformLabelGet',
                regExp: this.makeRegExp([0xa2, 0x01]),
                callback: (match) => {
                    this.socket.send(this.makeCommand([0xa2].concat(this.platformLabel)));
                },
            },
            {
                name: 'platformVersionGet',
                regExp: this.makeRegExp([0xa2, 0x02]),
                callback: (match) => {
                    this.socket.send(this.makeCommand([0xa2].concat(this.platformVersion)));
                },
            },
            {
                name: 'powerGet',
                regExp: this.makeRegExp(0x19),
                callback: (match) => {
                    this.socket.send(this.makeCommand([0x19, this.power ? 0x02 : 0x01]));
                },
            },
            {
                name: 'powerSet',
                regExp: this.makeRegExp(0x18, 1),
                callback: (match) => {
                    if (match[1] === '\x01' || match[1] === '\x02') {
                        this.power = match[1] === '\x02';
                        this.socket.send(this.makeCommand([0x00, 0x06]));
                    }
                    else {
                        this.socket.send(this.makeCommand([0x00, 0x15]));
                    }
                },
            },
            {
                name: 'serialNumberGet',
                regExp: this.makeRegExp(0x15),
                callback: (match) => {
                    this.socket.send(this.makeCommand([
                        0x15,
                        ...this.serialNumber.split('').map(x => x.charCodeAt(0)),
                    ]));
                },
            },
            {
                name: 'sicpVersionGet',
                regExp: this.makeRegExp([0xa2, 0x00]),
                callback: (match) => {
                    this.socket.send(this.makeCommand([0xa2].concat(this.sicpVersion)));
                },
            },
            {
                name: 'volumeGet',
                regExp: this.makeRegExp(0x45),
                callback: (match) => {
                    const speakerVolume = this.power ? this.speakerVolume : 0;
                    const audioOutVolume = this.power ? this.audioOutVolume : 0;
                    this.socket.send(this.makeCommand([0x45, speakerVolume, audioOutVolume]));
                },
            },
            {
                name: 'volumeSet',
                regExp: this.makeRegExp(0x44, 2),
                callback: (match) => {
                    const speakerVolume = match[1].charCodeAt(0);
                    const audioOutVolume = match[2].charCodeAt(1);
                    if (speakerVolume >= 0 &&
                        speakerVolume <= 100 &&
                        audioOutVolume >= 0 &&
                        audioOutVolume <= 100) {
                        this.speakerVolume = speakerVolume;
                        this.audioOutVolume = audioOutVolume;
                        this.socket.send(this.makeCommand([0x00, 0x06]));
                    }
                    else {
                        this.socket.send(this.makeCommand([0x00, 0x15]));
                    }
                },
            },
            {
                name: 'invalid',
                regExp: /.+/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0x00, 0x18]));
                },
            },
        ];
    }
    makeCommand(data) {
        const bytes = [
            data.length + 4,
            0x01,
            0x01,
            ...data,
        ];
        bytes.push(bytes.reduce((acc, curr) => acc ^ curr, 0)); // add checksum
        return AsciiText.decode(bytes);
    }
    makeRegExp(data, payloadLength = 0) {
        if (typeof data === 'number')
            data = [data];
        let length = 3; // length, control, and group bytes
        let str = '\x01[\\s\\S]';
        for (const d of data) {
            str += d < 16 ? `\\x0${d.toString(16)}` : `\\x${d.toString(16)}`;
            length++;
        }
        for (let i = 0; i < payloadLength; i++) {
            str += '([\\s\\S])';
            length++;
        }
        // checksum
        str += '[\\s\\S]';
        length++;
        str = (length < 16 ? `\\x0${length.toString(16)}` : `\\x${length.toString(16)}`) + str;
        return new RegExp(str);
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code.charCodeAt(0);
            if (this.input === code - 0x30)
                return;
            if (lowestCode === undefined || code < lowestCode) {
                lowestCode = code;
            }
        }
        this.input = (lowestCode !== null && lowestCode !== void 0 ? lowestCode : 0x3d) - 0x30;
    }
}
Philips.emulatorType = 'socketEmulator';
Philips.key = '-L7zG0u3-fjVmvA7601U';
